<template>
  <div style="min-width: 97%;">
    <div class="header-main">
      <div class="hm-left">
        <div>
          <div class="bread-crumb"></div>
          <div class="header-main__title-wrap">
            <h1 class="header-main__title">Коммуникации</h1>
            <div class="header-main__review"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="m-filter filter__wrap">
      <div class="endFilter" @click="toggleFilter">
        {{ displayFilter ? 'Свернуть фильтр' : 'Развернуть фильтр' }}
        <svg xmlns="http://www.w3.org/2000/svg" :class="{'rotated': displayFilter }" width="24" height="24" fill="#005EEB">
          <path d="M12.72 15.78a.75.75 0 0 1-.53.22h-.38a.77.77 0 0 1-.53-.22l-5.13-5.14a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0L12 13.67l4.44-4.45a.5.5 0 0 1 .71 0l.7.71a.5.5 0 0 1 0 .71l-5.13 5.14z"/>
        </svg>
      </div>

      <div class="contentFilter" v-if="displayFilter">
        <form @submit.prevent="applyFilters" class="default-form-filter">
          <div class="filter-content cleared filter__row">
            <!-- Дата -->
            <div class="filter-group">
              <label for="filter_date">Дата:</label>
              <div class="input_flex">
                <date-picker 
                  v-model="filters.date_gte"
                  :format="formatDate"
                  :language="language"
                  placeholder="От"
                  id="filter_date_gte"
                />
                <span> - </span>
                <date-picker 
                  v-model="filters.date_lte"
                  :format="formatDate"
                  :language="language"
                  placeholder="До"
                  id="filter_date_lte"
                />
              </div>
            </div>

            <!-- Тип -->
            <div class="filter-group">
              <label for="filter_type">Тип:</label>
              <select v-model="filters.type" id="filter_type">
                <option value="">Любой</option>
                <option value="incoming">Входящий</option>
                <option value="outgoing">Исходящий</option>
              </select>
            </div>

            <!-- Менеджеры -->
            <div class="filter-group">
              <label for="filter_managers">Менеджеры:</label>
              <TreeSelect
                v-model="filters.managers"
                :options="formattedManagersList"
                :multiple="true"
                :clearable="true"
                placeholder="Выберите значения"
                id="filter_managers"
                :normalizer="normalizeSiteData"
              />
            </div>

            <!-- Результаты -->
            <div class="filter-group">
              <label for="filter_results">Результаты:</label>
              <TreeSelect
                v-model="filters.results"
                :options="resultsList"
                :multiple="true"
                :clearable="true"
                placeholder="Выберите значения"
                id="filter_results"
                :normalizer="normalizeSiteData"
              />
            </div>

            <!-- Длительность -->
            <div class="filter-group">
              <label for="filter_duration">Длительность:</label>
              <div class="input_flex">
                <input 
                  v-model="filters.duration_gte" 
                  type="text" 
                  id="filter_duration_gte" 
                  placeholder="MM:CC"
                  v-mask="'##:##'"
                />
                <span> - </span>
                <input 
                  v-model="filters.duration_lte" 
                  type="text" 
                  id="filter_duration_lte" 
                  placeholder="MM:CC"
                  v-mask="'##:##'"
                />
              </div>
            </div>

            <!-- Заказ -->
            <div class="filter-group">
              <label for="filter_order">Заказ:</label>
              <input v-model="filters.order" type="text" id="filter_order" placeholder="Заказ">
            </div>

            <!-- Клиент -->
            <div class="filter-group">
              <label for="filter_client">Клиент:</label>
              <input v-model="filters.client" type="text" id="filter_client" placeholder="ФИО или телефон">
            </div>

            <!-- Внешний номер -->
            <div class="filter-group">
              <label for="filter_external_number">Внешний номер:</label>
              <input v-model="filters.external_number" type="text" id="filter_external_number" placeholder="Внешний номер телефона">
            </div>

            <!-- Order created at -->
            <div class="filter-group">
              <label for="filter_order_created_at">Order created at:</label>
              <div class="input_flex">
                <date-picker 
                  v-model="filters.order_created_at_gte"
                  :format="formatDate"
                  :language="language"
                  placeholder="От"
                  id="filter_order_created_at_gte"
                />
                <span> - </span>
                <date-picker 
                  v-model="filters.order_created_at_lte"
                  :format="formatDate"
                  :language="language"
                  placeholder="До"
                  id="filter_order_created_at_lte"
                />
              </div>
            </div>

            <!-- Телефон -->
            <div class="filter-group">
              <label for="filter_phone">Телефон:</label>
              <input v-model="filters.phone" type="text" id="filter_phone" placeholder="Телефон">
            </div>

            <!-- Магазин -->
            <div class="filter-group">
              <label for="filter_store">Магазин:</label>
              <select v-model="filters.store" id="filter_store">
                <option value="">Любой</option>
                <option v-for="store in storesList" :key="store.value" :value="store.value">
                  {{ store.label }}
                </option>
              </select>
            </div>

            <!-- Добавочный код -->
            <div class="filter-group">
              <label for="filter_extension_code">Добавочный код:</label>
              <input v-model="filters.extension_code" type="text" id="filter_extension_code" placeholder="Добавочный код">
            </div>

            <!-- Расшифровка -->
            <div class="filter-group">
              <label for="filter_transcription">Расшифровка:</label>
              <input v-model="filters.transcription" type="text" id="filter_transcription" placeholder="Расшифровка">
            </div>

            <!-- Теги -->
            <div class="filter-group">
              <label for="filter_tags">Теги:</label>
              <TreeSelect
                v-model="filters.tags"
                :options="tagsList"
                :multiple="true"
                :clearable="true"
                placeholder="Выберите значения"
                id="filter_tags"
                :normalizer="normalizeSiteData"
              />
            </div>

            <div class="filter__cleared">
              <button type="submit" class="apply text">
                <span class="ur-hr-no">Применить</span>
              </button>
              <span v-if="filtersApplied" class="filter-cancel" @click="resetFilters">
                <span class="ur-hr-no">Сброс</span>
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="container">
      <div class="m-box">
        <div class="modern-table-wrap">
          <div class="modern-table-container" style="position:relative">
            <LoaderTable v-if="loading"/>
            
            <table v-if="!loading" class="modern-table list">
              <thead>
                <tr>
                  <th>Дата и время</th>
                  <th>Добавочный код</th>
                  <th>Телефон</th>
                  <th>Заказ</th>
                  <th>Клиент</th>
                  <th>Тип</th>
                  <th>Результат</th>
                  <th>Длительность</th>
                  <th>Запись звонка</th>
                  <th>Менеджер</th>
                  <th>Ключевое слово</th>
                  <th>Содержание кампании</th>
                  <th>Кампания</th>
                  <th>Канал</th>
                  <th>Источник</th>
                  <th>Внешний номер</th>
                  <th>Время ожидания ответа оператора</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="calls.length === 0">
                  <td :colspan="17" style="text-align: center; padding: 40px; color: #636f7f;">
                    Нет данных для отображения
                  </td>
                </tr>
                <tr v-for="call in calls" :key="call.id">
                  <td>{{ formatDateTime(call.start_date) }}</td>
                  <td>{{ call.extension_code || '-' }}</td>
                  <td>{{ call.phone || '-' }}</td>
                  <td>
                    <router-link 
                      v-if="call.order_id" 
                      :to="{ name: 'OrderEdit', params: { orderId: call.order_id } }"
                      class="clickable tr-link important-flag__link"
                    >
                      {{ call.order_number || call.order_id }}
                    </router-link>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <router-link 
                      v-if="call.client_name" 
                      :to="{ name: 'OrderEdit', params: { orderId: call.order_id } }"
                      class="clickable tr-link important-flag__link"
                    >
                      {{ call.client_name }}
                    </router-link>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <span v-if="call.call_type === 'Входящий' || call.call_type === 'incoming'" class="call-type-badge incoming">Входящий</span>
                    <span v-else-if="call.call_type === 'Исходящий' || call.call_type === 'outgoing'" class="call-type-badge outgoing">Исходящий</span>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <span v-if="call.result === 'Принят' || call.result === 'answered'" class="result-badge accepted">Принят</span>
                    <span v-else-if="call.result === 'Пропущен' || call.result === 'missed'" class="result-badge missed">Пропущен</span>
                    <span v-else-if="call.result === 'В процессе' || call.result === 'pending'" class="result-badge pending">В процессе</span>
                    <span v-else>-</span>
                  </td>
                  <td>{{ call.duration ? call.duration.formatted : '-' }}</td>
                  <td>
                    <div v-if="call.audio_url" style="display: flex; gap: 10px;">
                      <button @click="playCall(call)" class="play-btn" title="Воспроизвести">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z"/>
                        </svg>
                      </button>
                      <a :href="call.audio_url" download class="download-btn" title="Скачать">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                        </svg>
                      </a>
                    </div>
                    <span v-else>-</span>
                  </td>
                  <td>{{ call.manager || '-' }}</td>
                  <td>{{ call.keyword || '-' }}</td>
                  <td>{{ call.campaign_content || '-' }}</td>
                  <td>{{ call.campaign || '-' }}</td>
                  <td>{{ call.channel || '-' }}</td>
                  <td>{{ call.source || '-' }}</td>
                  <td>{{ call.external_number || '-' }}</td>
                  <td>{{ call.operator_wait_time || '-' }}</td>
                </tr>
              </tbody>
            </table>

            <!-- Пагинация -->
            <div v-if="pagination && pagination.totalPageCount > 1" class="pagination">
              <button 
                @click="fetchCalls(pagination.currentPage - 1)" 
                :disabled="pagination.currentPage === 1"
                class="pagination-btn"
              >
                Назад
              </button>
              <span class="pagination-info">
                Страница {{ pagination.currentPage }} из {{ pagination.totalPageCount }}
              </span>
              <button 
                @click="fetchCalls(pagination.currentPage + 1)" 
                :disabled="pagination.currentPage >= pagination.totalPageCount"
                class="pagination-btn"
              >
                Вперед
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import LoaderTable from '@/components/LoaderTable.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ru from 'vue2-datepicker/locale/ru';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { VueMaskDirective } from 'v-mask';

Vue.directive('mask', VueMaskDirective);

export default {
  name: 'Communications',
  components: {
    LoaderTable,
    'date-picker': DatePicker,
    TreeSelect: Treeselect
  },
  data() {
    return {
      displayFilter: true,
      loading: false,
      calls: [],
      pagination: null,
      perPage: 50,
      currentPage: 1,
      filtersApplied: false,
      formatDate: 'YYYY-MM-DD',
      language: ru,
      filters: {
        date_gte: '',
        date_lte: '',
        type: '',
        managers: [],
        results: [],
        duration_gte: '',
        duration_lte: '',
        order: '',
        client: '',
        external_number: '',
        order_created_at_gte: '',
        order_created_at_lte: '',
        phone: '',
        store: '',
        extension_code: '',
        transcription: '',
        tags: []
      },
      managersList: [],
      resultsList: [
        { id: 'accepted', label: 'Принят' },
        { id: 'missed', label: 'Пропущен' },
        { id: 'rejected', label: 'Отклонен' }
      ],
      storesList: [],
      tagsList: []
    };
  },
  computed: {
    formattedManagersList() {
      return this.managersList.map(m => ({
        id: m.value,
        label: m.label
      }));
    }
  },
  mounted() {
    this.fetchCalls();
    this.fetchFilterData();
  },
  methods: {
    toggleFilter() {
      this.displayFilter = !this.displayFilter;
    },
    normalizeSiteData(node) {
      return {
        id: node.id,
        label: node.label
      };
    },
    formatDateTime(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString.replace(' ', 'T'));
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    },
    playCall(call) {
      if (call.audio_url) {
        const audio = new Audio(call.audio_url);
        audio.play();
      }
    },
    getFormattedDate(date) {
      if (!date) return '';
      if (typeof date === 'string') return date;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async fetchCalls(page = 1) {
      this.loading = true;
      try {
        const queryParams = new URLSearchParams({ page });
        
        if (this.perPage) queryParams.append('per_page', this.perPage);
        
        // Фильтры
        if (this.filters.date_gte) {
          queryParams.append('filter[start_date][gte]', this.getFormattedDate(this.filters.date_gte));
        }
        if (this.filters.date_lte) {
          queryParams.append('filter[start_date][lte]', this.getFormattedDate(this.filters.date_lte));
        }
        if (this.filters.phone) {
          queryParams.append('filter[phone]', this.filters.phone);
        }
        if (this.filters.order) {
          queryParams.append('filter[order_id]', this.filters.order);
        }
        if (this.filters.transcription) {
          queryParams.append('filter[transcription]', this.filters.transcription);
        }
        
        const response = await fetch(`https://manager.1akb.by/calls?${queryParams.toString()}`);
        const data = await response.json();
        
        if (data.success && data.calls) {
          this.calls = data.calls;
          this.pagination = data.pagination;
          this.currentPage = page;
        } else {
          this.calls = [];
          this.pagination = {
            limit: this.perPage,
            totalCount: 0,
            currentPage: 1,
            totalPageCount: 0
          };
        }
      } catch (error) {
        console.error('Ошибка при получении звонков:', error);
        this.calls = [];
      } finally {
        this.loading = false;
      }
    },
    applyFilters() {
      this.filtersApplied = true;
      this.fetchCalls(1);
    },
    resetFilters() {
      this.filters = {
        date_gte: '',
        date_lte: '',
        type: '',
        managers: [],
        results: [],
        duration_gte: '',
        duration_lte: '',
        order: '',
        client: '',
        external_number: '',
        order_created_at_gte: '',
        order_created_at_lte: '',
        phone: '',
        store: '',
        extension_code: '',
        transcription: '',
        tags: []
      };
      this.filtersApplied = false;
      this.fetchCalls(1);
    },
    async fetchFilterData() {
      // Загрузка данных для фильтров
      // TODO: Реализовать загрузку менеджеров, магазинов и тегов
    }
  }
};
</script>

<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.modern-table {
  background-color: #fff;
  position: relative;
}

.grid table.list, .m-box table.list, .stat-box-popup table.list {
  width: 100%;
}

.modern-table tr th {
  background: #f9fafb;
  border-bottom: 1px solid #dee2e6;
  border-left: none;
  color: #636f7f;
  font-size: 11px;
  font-weight: 400;
  padding: 14px 5px;
  text-align: right;
}

.grid table.list td, .grid table.list th, .m-box table.list td, .m-box table.list th, .stat-box-popup table.list td, .stat-box-popup table.list th {
  padding-left: 15px;
  padding-right: 15px;
}

.grid table.list th, .m-box table.list th, .stat-box-popup table.list th {
  color: #636f7f;
  cursor: default;
  font-size: 11px;
  font-weight: 400;
  height: 41px;
  line-height: 12px;
  padding-bottom: 5px;
  padding-top: 6px;
}

.grid table.list tr td:first-child, .grid table.list tr th:first-child, .m-box table.list tr td:first-child, .m-box table.list tr th:first-child, .stat-box-popup table.list tr td:first-child, .stat-box-popup table.list tr th:first-child {
  padding-left: 20px;
}

.modern-table tr td {
  border-bottom: 1px solid #dee2e6 !important;
  color: #1e2248;
  font-size: 12px;
  padding: 8px 5px !important;
  text-align: right;
  vertical-align: middle;
}

.modern-table.list tr td {
  font-size: 13px;
}

.grid table.list td, .m-box table.list td, .stat-box-popup table.list td {
  padding-bottom: 15px;
  padding-top: 15px;
}

.grid table.list td:not(.numeric):not(.price), .grid table.list th:not(.numeric):not(.price), .m-box table.list td:not(.numeric):not(.price), .m-box table.list th:not(.numeric):not(.price), .stat-box-popup table.list td:not(.numeric):not(.price), .stat-box-popup table.list th:not(.numeric):not(.price) {
  text-align: left;
}

.modern-table tr:hover {
  background-color: #f9fafb;
}

.play-btn, .download-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  color: #005EEB;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.play-btn:hover, .download-btn:hover {
  opacity: 0.7;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
  padding: 20px;
}

.pagination-btn {
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  background: #fff;
  cursor: pointer;
  border-radius: 4px;
  color: #1e2248;
  font-size: 14px;
}

.pagination-btn:hover:not(:disabled) {
  background-color: #f4f6f8;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-info {
  font-size: 14px;
  color: #636f7f;
}

.container {
  margin: 0 auto;
  padding-left: 0px;
  padding-right: 0px;
  width: 100%;
}

.m-box {
  background-color: transparent;
  border: none;
  border-radius: 4px;
  clear: left;
  margin-bottom: 30px;
  min-height: 95px;
  position: relative;
}

.modern-table-wrap {
  display: flex;
  flex-flow: row nowrap;
  position: relative;
}

.modern-table-container {
  webkit-backface-visibility: hidden;
  flex: 1 1 auto;
  overflow-x: auto;
}

table td {
  empty-cells: show;
}

.modern-table tr td:first-child, .modern-table tr th:first-child {
  padding-left: 20px;
}

.important-flag, .important-flag__link {
  margin-bottom: 5px;
  margin-right: 3px;
  vertical-align: middle;
  color: #0052cc;
  text-decoration: none;
  cursor: pointer;
}

.important-flag, .important-flag__link:hover {
  opacity: .5;
}

.modern-table .tr-link {
  line-height: 17px;
  margin-right: 3px;
  vertical-align: middle;
}

.modern-table .tr-link:last-child {
  margin-right: 0;
}

.clickable {
  cursor: pointer;
}

.call-type-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.call-type-badge.incoming {
  background-color: #e3f2fd;
  color: #1976d2;
}

.call-type-badge.outgoing {
  background-color: #f3e5f5;
  color: #7b1fa2;
}

.result-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.result-badge.accepted {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.result-badge.missed {
  background-color: #ffebee;
  color: #c62828;
}

.result-badge.pending {
  background-color: #fff3e0;
  color: #e65100;
}

.m-filter {
  background-color: #fff;
  clear: both;
  padding-bottom: 65px;
  position: relative;
}

.m-filter .filter-content {
  overflow: visible;
  padding-bottom: 8px;
  padding-top: 19px;
}

.m-filter .filter__row {
  font-size: 0;
  margin-left: -15px;
  margin-right: -15px;
  min-height: 36px;
  position: relative;
  transition: min-height .3s ease;
}

.m-filter .filter-group {
  float: left;
  font-size: 0;
  letter-spacing: -1px;
  line-height: 0;
  margin-bottom: 15px;
  opacity: 1;
  padding: 0 15px;
  transition: opacity .8s ease;
  width: 25%;
}

body .m-filter .filter-group {
  display: inline-block;
  float: none;
  min-width: 249px;
  vertical-align: top;
}

@media screen and (max-width: 1389px) {
  body .m-filter .filter-group {
    width: 25%;
  }
}

@media screen and (max-width: 1141px) {
  body .m-filter .filter-group {
    min-width: inherit;
  }
}

.m-filter label {
  display: inline-block;
  font-style: normal;
}

.m-filter .filter-group label {
  color: #636f7f;
  display: block;
}

.m-filter .filter-group .chosen-container, 
.m-filter .filter-group .chosen-container-single, 
.m-filter .filter-group .flags-in-filter, 
.m-filter .filter-group .input-dash, 
.m-filter .filter-group .selectbox, 
.m-filter .filter-group input[type=email], 
.m-filter .filter-group input[type=number], 
.m-filter .filter-group input[type=password], 
.m-filter .filter-group input[type=text], 
.m-filter .filter-group input[type=time], 
.m-filter .filter-group label, 
.m-filter .filter-group>div {
  font-size: 13px;
  letter-spacing: 0;
  line-height: 1.1;
}

.filter-group .chosen-container-single:not(.chosen-container_inline) .chosen-single, 
.filter-group input[type=email], 
.filter-group input[type=number], 
.filter-group input[type=password], 
.filter-group input[type=text], 
.filter-group input[type=time], 
.filter-group select, 
.filter-group span.selectbox {
  clear: left;
  display: inline-block;
  width: 100%;
}

.m-filter .filter-group .selectbox .select, 
.m-filter .filter-group input[type=email], 
.m-filter .filter-group input[type=number], 
.m-filter .filter-group input[type=password], 
.m-filter .filter-group input[type=text], 
.m-filter .filter-group input[type=time], 
.m-filter .filter-group select {
  border: 1px solid var(--input-border-color, #dee2e6);
  border-radius: var(--input-border-radius, 4px);
  color: var(--input-color, #1e2248);
  font-size: var(--input-font-size, 13px);
  height: var(--input-height, 36px);
  line-height: var(--input-line-height, 1.1);
  padding: var(--input-padding, 8px 12px);
  transition: var(--input-transition, border-color 0.15s ease-in-out);
}

.default-form-filter {
  position: relative;
  margin: 0 auto;
  padding-left: 25px;
  padding-right: 25px;
  width: 100%;
}

.input_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.input_flex > * {
  flex: 1;
}

.endFilter {
  color: #0044b7;
  padding: 10px;
  cursor: pointer;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.endFilter svg {
  border: 1px solid #c9d7ee;
  margin-left: 5px;
}

.rotated {
  transform: rotate(180deg);
}

.filter__cleared {
  display: flex;
  width: 100%;
  margin: 10px 15px;
}

.m-filter .apply {
  background: none;
  background-color: #fff;
  background-image: linear-gradient(180deg, #fff, #e9ecee);
  border: 1px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
}

.m-filter .apply, .m-filter .apply:focus {
  outline: none;
}

.m-filter .apply, .m-filter .apply.active, .m-filter .apply:active, .m-filter .apply:hover {
  color: #1e2248;
  text-decoration: none;
}

.m-filter .apply .ur-hr-no, .m-filter .filter-cancel .ur-hr-no {
  display: inline-block;
  line-height: 1;
}

.m-filter .apply.active, .m-filter .apply:active {
  background-color: #dee2e6;
  background-image: none;
  border-color: #afb9c3;
}

.m-filter .apply:hover {
  background-color: #f4f6f8;
  background-image: none;
}

.m-filter .filter-cancel {
  background: none;
  background-color: #fff;
  background-image: linear-gradient(180deg, #fff, #e9ecee);
  border: 1px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
  font-size: 14px;
  font-size: 0;
  font-weight: 400;
  height: 36px;
  line-height: 1.5;
  padding: 0;
  position: relative;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  width: 36px;
}

.m-filter .apply+.filter-cancel {
  margin-left: 8px;
}

.m-filter .filter-cancel:before {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
  background-position: 50%;
  background-repeat: no-repeat;
  bottom: 0;
  content: "";
  height: 24px;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 24px;
}

.m-filter .filter-cancel .ur-hr-no {
  display: inline-block;
  line-height: 1;
}

.m-filter+div {
  margin-top: -42px;
}

.m-filter+div, .m-filter>.container {
  position: relative;
  margin: 0px;
  width: 100%;
  max-width: 100%;
  padding: 0px;
}

.m-box {
  background-color: transparent;
  border: none;
}

.modern-table {
  background-color: #fff;
  position: relative;
}

.modern-table tr th {
  background: #f9fafb;
  border-bottom: 1px solid #dee2e6;
  border-left: none;
  color: #636f7f;
  font-size: 11px;
  font-weight: 400;
  padding: 12px 8px;
  text-align: left;
  white-space: nowrap;
}

.modern-table tr td {
  border-bottom: 1px solid #dee2e6;
  color: #1e2248;
  font-size: 13px;
  padding: 12px 8px;
  vertical-align: middle;
}
</style>

